module.exports = __webpack_public_path__ + "static/media/homem_olhando_computador.c122759e.jpg";